var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-tooltip",
        {
          staticClass: "item",
          attrs: {
            effect: "dark",
            content: _vm.$t("pbcRsDashboardTooltip"),
            placement: "left",
            "popper-class": "popper-cls",
          },
        },
        [
          _c(
            "span",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.rsDashboardLoading,
                  expression: "rsDashboardLoading",
                },
              ],
              class: ["entry-btn", _vm.disabled ? "entry-btn-disabled" : ""],
              attrs: { "element-loading-spinner": "el-icon-loading" },
              on: { click: _vm.onEntryBtnClick },
            },
            [
              _c("img", {
                staticClass: "history-icon",
                attrs: { src: _vm.rsdashboard_icon, alt: "" },
              }),
            ]
          ),
        ]
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.show,
            size: "60%",
            "custom-class": "rsdashboard_class",
          },
          on: {
            "update:visible": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "drawer-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c(
                "div",
                { staticClass: "drawer-title-text" },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("aDashboard_title")) +
                      "\n                "
                  ),
                  _c("GuidanceTooltip", {
                    staticClass: "guidanceTooltip",
                    attrs: {
                      content: _vm.$t("pbc_rsdashboard_tip"),
                      placement: "right",
                      jumpLink: _vm.$t("pbc_rsdashboard_link"),
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "valueTypeSwitch" },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "value" },
                      model: {
                        value: _vm.valueType,
                        callback: function ($$v) {
                          _vm.valueType = $$v
                        },
                        expression: "valueType",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("LIMIT_NUM")))]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: "percent" },
                      model: {
                        value: _vm.valueType,
                        callback: function ($$v) {
                          _vm.valueType = $$v
                        },
                        expression: "valueType",
                      },
                    },
                    [_vm._v(" % ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { key: _vm.flexColumnKey, ref: "area", staticClass: "flex-column" },
            [
              _c(
                "div",
                { staticClass: "level-0-container" },
                [
                  _c("div", { staticClass: "level-0-1" }, [
                    _c("div", [
                      _c("span", { staticClass: "level-0-1-count" }, [
                        _vm._v(" " + _vm._s(_vm.data.pbcTotal) + " "),
                      ]),
                    ]),
                    _c("div", { staticClass: "level-0-1-title" }, [
                      _vm._v(_vm._s(_vm.$t("pbc_items_total"))),
                    ]),
                  ]),
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: _vm.$t("outstanding_PBC_requests_count_TIP"),
                        placement: "bottom",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "level-0 card-clickable",
                          on: {
                            click: function ($event) {
                              return _vm.onCardClick("02")
                            },
                          },
                        },
                        [
                          _c("div", [
                            _c("span", { staticClass: "level-0-count" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.valueType == "value"
                                      ? _vm.data.level1[0].count
                                      : `${_vm.data.level1[0].percent} %`
                                  ) +
                                  " "
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "level-0-title" }, [
                            _vm._v(_vm._s(_vm.data.level1[0].title)),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-steps",
                { staticClass: "steps", attrs: { direction: "vertical" } },
                [
                  _c("el-step", [
                    _c(
                      "div",
                      {
                        staticClass: "step-title",
                        attrs: { slot: "title" },
                        slot: "title",
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("rsdashboard_level1")) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _c("div", { attrs: { slot: "icon" }, slot: "icon" }, [
                      _c("img", {
                        staticClass: "level-icon",
                        attrs: { src: _vm.level1Icon, alt: "" },
                      }),
                    ]),
                    _c(
                      "div",
                      {
                        class: ["level", `level-1-container`],
                        attrs: { slot: "description" },
                        slot: "description",
                      },
                      _vm._l(
                        _vm.data.level1.filter((v, k) => k > 0),
                        function (v, k) {
                          return _c(
                            "el-tooltip",
                            {
                              key: `level1-${k}`,
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: v.tip,
                                placement: "bottom",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: [
                                    "card",
                                    `card-green`,
                                    "card-clickable",
                                  ],
                                  on: {
                                    click: function ($event) {
                                      _vm.onCardClick(`1${k + 1}`)
                                    },
                                  },
                                },
                                [
                                  _c("div", { staticClass: "card-top" }, [
                                    _c(
                                      "div",
                                      { staticClass: "card-top-right" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "card-top-right-line1",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.valueType == "value" ||
                                                  v.hidePercent
                                                  ? v.count
                                                  : `${v.percent} %`
                                              )
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "card-top-right-line2",
                                          },
                                          [_vm._v(_vm._s(v.title))]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      1
                    ),
                  ]),
                  _c("el-step", [
                    _c(
                      "div",
                      {
                        staticClass: "step-title",
                        attrs: { slot: "title" },
                        slot: "title",
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.$t("rsdashboard_level2")) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _c("div", { attrs: { slot: "icon" }, slot: "icon" }, [
                      _c("img", {
                        staticClass: "level-icon",
                        attrs: { src: _vm.level2Icon, alt: "" },
                      }),
                    ]),
                    _c(
                      "div",
                      {
                        class: ["level", `level-2-container`],
                        attrs: { slot: "description" },
                        slot: "description",
                      },
                      _vm._l(_vm.data.level2, function (v, k) {
                        return _c(
                          "el-tooltip",
                          {
                            key: `level2-${k}`,
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              placement: "bottom",
                              disabled: v.tip == "",
                            },
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: { innerHTML: _vm._s(v.tip) },
                              slot: "content",
                            }),
                            _c("div", { class: ["card", `card-green`] }, [
                              _c("div", { staticClass: "card-top" }, [
                                _c("div", { staticClass: "card-top-left" }, [
                                  _c("img", {
                                    attrs: {
                                      src: [
                                        _vm.smellIcon,
                                        _vm.sadIcon,
                                        _vm.sadIcon,
                                        _vm.normalIcon,
                                      ][k],
                                    },
                                  }),
                                ]),
                                _c("div", { staticClass: "card-top-right" }, [
                                  _c(
                                    "div",
                                    { staticClass: "card-top-right-line1" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.valueType == "value" ||
                                            v.hidePercent
                                            ? v.count
                                            : `${v.percent} %`
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "card-top-right-line2" },
                                    [_vm._v(_vm._s(v.title))]
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ]),
                  _c(
                    "el-step",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.exportLoading,
                          expression: "!exportLoading",
                        },
                      ],
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "step-title",
                          attrs: { slot: "title" },
                          slot: "title",
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("rsdashboard_level3")) +
                              "\n                    "
                          ),
                        ]
                      ),
                      _c("div", { attrs: { slot: "icon" }, slot: "icon" }, [
                        _c("img", {
                          staticClass: "level-icon",
                          attrs: { src: _vm.level3Icon, alt: "" },
                        }),
                      ]),
                      _c(
                        "div",
                        {
                          class: ["level", `level-3-container`],
                          attrs: { slot: "description" },
                          slot: "description",
                        },
                        [
                          _c(
                            "el-tabs",
                            {
                              on: { "tab-click": _vm.onTabClick },
                              model: {
                                value: _vm.activeTab,
                                callback: function ($$v) {
                                  _vm.activeTab = $$v
                                },
                                expression: "activeTab",
                              },
                            },
                            [
                              _c("el-tab-pane", {
                                attrs: {
                                  label: _vm.$t("COMMON_ENTITY"),
                                  name: "entity",
                                },
                              }),
                              _c("el-tab-pane", {
                                attrs: {
                                  label: _vm.$t("TABLE_HEADER_clientUserName"),
                                  name: "cleintResponsbile",
                                },
                              }),
                              _c("el-tab-pane", {
                                attrs: {
                                  label: _vm.$t("TABLE_HEADER_topicName"),
                                  name: "account",
                                },
                              }),
                              _c("el-tab-pane", {
                                attrs: {
                                  label: _vm.$t("TABLE_HEADER_sub_topicName"),
                                  name: "subAccount",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.dashboardTableLoading,
                                  expression: "dashboardTableLoading",
                                },
                              ],
                              attrs: {
                                data: _vm.data.level3,
                                "max-height": "400",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "target",
                                  label: {
                                    entity: _vm.$t("COMMON_ENTITY"),
                                    cleintResponsbile: _vm.$t(
                                      "TABLE_HEADER_clientUserName"
                                    ),
                                    accoun: _vm.$t("TABLE_HEADER_topicName"),
                                    subAccoun: _vm.$t(
                                      "TABLE_HEADER_sub_topicName"
                                    ),
                                  }[_vm.activeTab],
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t(
                                    "submitted_before_deadline_pbc_request"
                                  ),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.valueType == "value"
                                                  ? scope.row.value21
                                                  : `${scope.row.percent21}
                                        %`
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: { label: _vm.$t("overdued_pbc_count") },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.valueType == "value"
                                                  ? scope.row.value22
                                                  : `${scope.row.percent22}
                                        %`
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "value23",
                                  label: _vm.$t("overdued_on_average"),
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: _vm.$t("revision_required_count"),
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.valueType == "value"
                                                  ? scope.row.value24
                                                  : `${scope.row.percent24}
                                        %`
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }